import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { pluginBarraMinima, semItensVazios } from "../utils/chartMinBar";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const plugins = [pluginBarraMinima("proximosMetaBarraMinima", 40, "horizontal")];

const formatK = (value) => {
  if (value == null || value === 0) return "";
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  if (n >= 1_000_000) return `${parseFloat((n / 1_000_000).toFixed(2))}m`;
  if (n >= 1_000) return `${parseFloat((n / 1_000).toFixed(2))}k`;
  return parseFloat(n.toFixed(2)).toString();
};

const options = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { right: 20 } },
  plugins: {
    legend: {
      position: "bottom",
      align: "start",
      labels: {
        font: { size: 11 },
        color: "#364153",
        padding: 16,
        usePointStyle: true,
        pointStyle: "rectRounded",
        pointStyleWidth: 14,
        boxHeight: 10,
      },
    },
    tooltip: {
      callbacks: {
        label: (ctx) => ` ${ctx.dataset.label}: ${formatK(ctx.raw)}`,
      },
    },
    datalabels: {
      anchor: "center",
      align: "center",
      color: "#fff",
      font: { size: 10, weight: "bold" },
      formatter: (value) => formatK(value),
    },
  },
  scales: {
    x: {
      stacked: true,
      display: false,
      grid: { display: false },
      beginAtZero: true,
    },
    y: {
      stacked: true,
      grid: { display: false },
      border: { display: false },
      ticks: {
        font: { size: 9, lineHeight: 1.1 },
        color: "#364153",
        maxRotation: 0,
        crossAlign: "far",
      },
    },
  },
};

const TopProximosMeta = ({ labels = [], atingidoData = [], gapData = [] }) => {
  const chartData = useMemo(() => {
    const { labels: itens, series } = semItensVazios(labels, [atingidoData, gapData]);
    const [atingido, gap] = series;
    const hasAtingidoAt = (dataIndex) => atingido[dataIndex] != null;
    const hasGapAt = (dataIndex) => gap[dataIndex] != null;

    return {
      labels: itens,
      datasets: [
        {
          label: "Atingido (t)",
          data: atingido,
          backgroundColor: "#003DA5",
          borderRadius: (ctx) => ({
            topLeft: 3,
            bottomLeft: 3,
            topRight: hasGapAt(ctx.dataIndex) ? 0 : 3,
            bottomRight: hasGapAt(ctx.dataIndex) ? 0 : 3,
          }),
          barPercentage: 0.75,
          categoryPercentage: 0.85,
        },
        {
          label: "Gap (t)",
          data: gap,
          backgroundColor: "#0096FF",
          borderRadius: (ctx) => ({
            topRight: 3,
            bottomRight: 3,
            topLeft: hasAtingidoAt(ctx.dataIndex) ? 0 : 3,
            bottomLeft: hasAtingidoAt(ctx.dataIndex) ? 0 : 3,
          }),
          barPercentage: 0.75,
          categoryPercentage: 0.85,
        },
      ],
    };
  }, [labels, atingidoData, gapData]);

  const semDados = chartData.labels.length === 0;

  return (
    <div className="bg-white rounded-lg p-6 flex-1 min-w-0" style={{ boxShadow: "0 1px 6px 0 rgba(0,0,0,0.10)" }}>
      <h2 className="text-[20px] font-bold mb-2" style={{ color: "#01054C" }}>TOP 5 – Próximos da Meta</h2>
      <div style={{ height: 240 }}>
        {semDados ? (
          <div className="flex h-full items-center justify-center">
            <p className="text-center text-sm font-semibold text-[#01054C]">
              Todos os clientes atingiram a meta no mês
            </p>
          </div>
        ) : (
          <Bar data={chartData} options={options} plugins={plugins} />
        )}
      </div>
    </div>
  );
};

export default TopProximosMeta;
